import Actor from "../../actors/Actor";
import common from "../../common";

export default class Whisk extends Actor{
    constructor(texture, position) {
        super(texture);
        this._animating = false;
        this.x = position.x;
        this.y = position.y;
        this._startingPosition = position;
        this._continueMixing = false;
    }

    update() {
    }

    animateSingle(){
        new P3.utils.TWEEN.Tween(this)
            .to({
                x: this._startingPosition.x + 200,
                rotation: common.deg2rad(-5)
            }, 550)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .repeat(3)
            .yoyo(true)
            .onComplete(()=> {
                this._animating = false;
                this.position = this._startingPosition;
            })
            .onStart(()=> {
                this._animating = true;
                P3.audio.playSound('sfx_mix_loop_00');
            })
            .start();
    }

    animateContinuous(){
        this._continousTween = new P3.utils.TWEEN.Tween(this)
            .to({
                x: this._startingPosition.x + 200,
                rotation: common.deg2rad(-5)
            }, 650)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .repeat(1)
            .yoyo(true)
            .onStart(()=>{
                this._animating = true;
                P3.audio.playSound('sfx_mix_loop_00');
            })
            .onComplete(()=>{
                if(this._continueMixing){
                    this.animateContinuous();
                }
                this._animating = false;
            })
            .yoyo(true)
            .start();
    }

    animateUp(){
        new P3.utils.TWEEN.Tween(this)
            .to({
                y: this._startingPosition.y - 100
            }, 2000)
            .easing(P3.utils.Easing.Back2.Out)
            .onComplete(()=>{
                this._continueMixing = true;
                this.animateContinuous();
                this._animating = false;
            })
            .start();
    }

    animateDown(){
        new P3.utils.TWEEN.Tween(this)
            .to({
                y: this._startingPosition.y
            }, 2000)
            .easing(P3.utils.Easing.Back2.In)
            .onComplete(()=>{
                // this.animateContinuous();
                // this._continueMixing = true;
                this._animating = false;
            })
            .start();
    }
}